import React from 'react';
import { withStyles } from '@mui/styles';
import RichTextEditor from 'react-rte';
import clsx from 'clsx';

const MAX_CHAR = 20000;

const styles = theme => ({
    textEditor: {
        border: `2px solid ${theme.palette.grey[300]}`,
        '& a': {
            color: theme.palette.primary.main
        }
    },
    textEditorError: {
        borderColor: theme.palette.red.primary
    },
    counterLabel: {
        marginTop: 3,
        color: theme.palette.grey[500],
        width: '100%',
        fontSize: 10,
        textAlign: 'right',
        fontWeight: 600
    },
    errorLabel: {
        color: `${theme.palette.red.primary} !important`,
        fontSize: 10,
        fontWeight: 600
    },
    excludeImg: {
        '& .EditorToolbar__root___3_Aqz :nth-child(5)': {
            display: 'none'
        }
    }
});

class RichTextEditorCustom extends React.Component {
     lastHtml = '';

     componentDidMount() {
         const { value } = this.props;
         this.lastHtml = value ? value.toString('html') : '';
     }

     componentDidUpdate(prevProps) {
         if (prevProps.value !== this.props.value) {
             this.lastHtml = this.props.value ? this.props.value.toString('html') : '';
         }
     }

    getMessageLength = value => value.toString('html').replace(/<(?:.|\n)*?>/gm, '').length;

      handleChange = (nextValue) => {
          const { onChange } = this.props;
          const nextHtml = nextValue.toString('html');

          if (nextHtml !== this.lastHtml) {
              this.lastHtml = nextHtml;
              onChange && onChange(nextValue);
          }
      };

      render() {
          const { classes, value, placeholder = '', required, className, onChange, error, maxCharacters = MAX_CHAR, excludeImg, noCounter } = this.props;
          const charactersLeft = maxCharacters - this.getMessageLength(value);

          return (
              <div className={excludeImg && classes.excludeImg}>
                  <RichTextEditor
                      className={clsx(classes.textEditor, error && classes.textEditorError, 'c-text-editor', className)}
                      placeholder={placeholder}
                      value={value}
                      onChange={this.handleChange}
                      onBlur={() => {}}
                  />
                  <div className="u-dsp--distribute u-mrg--tx1">
                      {
                          error ? (
                              <span className={classes.errorLabel}>{error}</span>
                          ) : <span />
                      }
                      {!noCounter && (
                          <span className={clsx(classes.counterLabel, (required && charactersLeft === maxCharacters) && classes.errorLabel)}>
                              {charactersLeft} characters remaining
                          </span>
                      )}
                  </div>
              </div>
          );
      }
}

export default withStyles(styles)(RichTextEditorCustom);
